import {environment} from '../environment/environment';

export const apiAutocomplete = {
    GET_AUTOCOMPLETE: {
        url: `${environment.url_geocoder_api}json?&api-version=1.0&subscription-key=rdeaQcF3Ap8iPmjs0SMJCZbcLxiDFVre1yX9prqC5mU&language=fr-FR&query={query}&limit=10`
    },
    AUTOCOMPLETE_SPACE: {
        space: '%20'
    },
    AUTOCOMPLETE_ERROR: {
        error: 'Error'
    },
};

export const PoisType = {
    ACCESS_GATEWAY: 'geocoder.poi.ACCESS_GATEWAY',
    ADMINISTRATIVE_DIVISION: 'geocoder.poi.ADMINISTRATIVE_DIVISION',
    ADVENTURE_SPORTS_VENUE: 'geocoder.poi.ADVENTURE_SPORTS_VENUE',
    AGRICULTURE: 'geocoder.poi.AGRICULTURE',
    AIRPORT: 'geocoder.poi.AIRPORT',
    AMUSEMENT_PARK: 'geocoder.poi.AMUSEMENT_PARK',
    AUTOMOTIVE_DEALER: 'geocoder.poi.AUTOMOTIVE_DEALER',
    BANK: 'geocoder.poi.BANK',
    BEACH: 'geocoder.poi.BEACH',
    BUILDING_POINT: 'geocoder.poi.BUILDING_POINT',
    BUSINESS_PARK: 'geocoder.poi.BUSINESS_PARK',
    CAFE_PUB: 'geocoder.poi.CAFE_PUB',
    CAMPING_GROUND: 'geocoder.poi.CAMPING_GROUND',
    CAR_WASH: 'geocoder.poi.CAR_WASH',
    CASH_DISPENSER: 'geocoder.poi.CASH_DISPENSER',
    CASINO: 'geocoder.poi.CASINO',
    CINEMA: 'geocoder.poi.CINEMA',
    CITY_CENTER: 'geocoder.poi.CITY_CENTER',
    CLUB_ASSOCIATION: 'geocoder.poi.CLUB_ASSOCIATION',
    COLLEGE_UNIVERSITY: 'geocoder.poi.COLLEGE_UNIVERSITY',
    COMMERCIAL_BUILDING: 'geocoder.poi.COMMERCIAL_BUILDING',
    COMMUNITY_CENTER: 'geocoder.poi.COMMUNITY_CENTER',
    COMPANY: 'geocoder.poi.COMPANY',
    COURTHOUSE: 'geocoder.poi.COURTHOUSE',
    CULTURAL_CENTER: 'geocoder.poi.CULTURAL_CENTER',
    DENTIST: 'geocoder.poi.DENTIST',
    DEPARTMENT_STORE: 'geocoder.poi.DEPARTMENT_STORE',
    DOCTOR: 'geocoder.poi.DOCTOR',
    ELECTRIC_VEHICLE_STATION: 'geocoder.poi.ELECTRIC_VEHICLE_STATION',
    EMBASSY: 'geocoder.poi.EMBASSY',
    EMERGENCY_MEDICAL_SERVICE: 'geocoder.poi.EMERGENCY_MEDICAL_SERVICE',
    ENTERTAINMENT: 'geocoder.poi.ENTERTAINMENT',
    EXCHANGE: 'geocoder.poi.EXCHANGE',
    EXHIBITION_CONVENTION_CENTER: 'geocoder.poi.EXHIBITION_CONVENTION_CENTER',
    FERRY_TERMINAL: 'geocoder.poi.FERRY_TERMINAL',
    FIRE_STATION_BRIGADE: 'geocoder.poi.FIRE_STATION_BRIGADE',
    FRONTIER_CROSSING: 'geocoder.poi.FRONTIER_CROSSING',
    FUEL_FACILITIES: 'geocoder.poi.FUEL_FACILITIES',
    GOLF_COURSE: 'geocoder.poi.GOLF_COURSE',
    GOVERNMENT_OFFICE: 'geocoder.poi.GOVERNMENT_OFFICE',
    HEALTH_CARE_SERVICE: 'geocoder.poi.HEALTH_CARE_SERVICE',
    HELIPAD_HELICOPTER_LANDING: 'geocoder.poi.HELIPAD_HELICOPTER_LANDING',
    HOLIDAY_RENTAL: 'geocoder.poi.HOLIDAY_RENTAL',
    HOSPITAL_POLYCLINIC: 'geocoder.poi.HOSPITAL_POLYCLINIC',
    HOTEL_MOTEL: 'geocoder.poi.HOTEL_MOTEL',
    ICE_SKATING_RINK: 'geocoder.poi.ICE_SKATING_RINK',
    IMPORTANT_TOURIST_ATTRACTION: 'geocoder.poi.IMPORTANT_TOURIST_ATTRACTION',
    INDUSTRIAL_BUILDING: 'geocoder.poi.INDUSTRIAL_BUILDING',
    LEISURE_CENTER: 'geocoder.poi.LEISURE_CENTER',
    LIBRARY: 'geocoder.poi.LIBRARY',
    MANUFACTURING_FACILITY: 'geocoder.poi.MANUFACTURING_FACILITY',
    MARINA: 'geocoder.poi.MARINA',
    MARKET: 'geocoder.poi.MARKET',
    MEDIA_FACILITY: 'geocoder.poi.MEDIA_FACILITY',
    MILITARY_INSTALLATION: 'geocoder.poi.MILITARY_INSTALLATION',
    MOTORING_ORGANIZATION_OFFICE: 'geocoder.poi.MOTORING_ORGANIZATION_OFFICE',
    MOUNTAIN_PASS: 'geocoder.poi.MOUNTAIN_PASS',
    MUSEUM: 'geocoder.poi.MUSEUM',
    NATIVE_RESERVATION: 'geocoder.poi.NATIVE_RESERVATION',
    NIGHTLIFE: 'geocoder.poi.NIGHTLIFE',
    NON_GOVERNMENTAL_ORGANIZATION: 'geocoder.poi.NON_GOVERNMENTAL_ORGANIZATION',
    OPEN_PARKING_AREA: 'geocoder.poi.OPEN_PARKING_AREA',
    OTHER: 'geocoder.poi.OTHER',
    PARKING_GARAGE: 'geocoder.poi.PARKING_GARAGE',
    PARK_RECREATION_AREA: 'geocoder.poi.PARK_RECREATION_AREA',
    PETROL_STATION: 'geocoder.poi.PETROL_STATION',
    PHARMACY: 'geocoder.poi.PHARMACY',
    PLACE_OF_WORSHIP: 'geocoder.poi.PLACE_OF_WORSHIP',
    POLICE_STATION: 'geocoder.poi.POLICE_STATION',
    PORT_WAREHOUSE_FACILITY: 'geocoder.poi.PORT_WAREHOUSE_FACILITY',
    POST_OFFICE: 'geocoder.poi.POST_OFFICE',
    PRIMARY_RESOURCE_UTILITY: 'geocoder.poi.PRIMARY_RESOURCE_UTILITY',
    PRISON_CORRECTIONAL_FACILITY: 'geocoder.poi.PRISON_CORRECTIONAL_FACILITY',
    PUBLIC_AMENITY: 'geocoder.poi.PUBLIC_AMENITY',
    PUBLIC_TRANSPORT_STOP: 'geocoder.poi.PUBLIC_TRANSPORT_STOP',
    RAILWAY_STATION: 'geocoder.poi.RAILWAY_STATION',
    RENT_A_CAR_FACILITY: 'geocoder.poi.RENT_A_CAR_FACILITY',
    RENT_A_CAR_PARKING: 'geocoder.poi.RENT_A_CAR_PARKING',
    REPAIR_FACILITY: 'geocoder.poi.REPAIR_FACILITY',
    RESEARCH_FACILITY: 'geocoder.poi.RESEARCH_FACILITY',
    RESIDENTIAL_ACCOMMODATION: 'geocoder.poi.RESIDENTIAL_ACCOMMODATION',
    RESTAURANT: 'geocoder.poi.RESTAURANT',
    RESTAURANT_AREA: 'geocoder.poi.RESTAURANT_AREA',
    REST_AREA: 'geocoder.poi.REST_AREA',
    SCENIC_PANORAMIC_VIEW: 'geocoder.poi.SCENIC_PANORAMIC_VIEW',
    SCHOOL: 'geocoder.poi.SCHOOL',
    SHOP: 'geocoder.poi.SHOP',
    SHOPPING_CENTER: 'geocoder.poi.SHOPPING_CENTER',
    SPORTS_CENTER: 'geocoder.poi.SPORTS_CENTER',
    STADIUM: 'geocoder.poi.STADIUM',
    SWIMMING_POOL: 'geocoder.poi.SWIMMING_POOL',
    TENNIS_COURT: 'geocoder.poi.TENNIS_COURT',
    THEATER: 'geocoder.poi.THEATER',
    TOURIST_INFORMATION_OFFICE: 'geocoder.poi.TOURIST_INFORMATION_OFFICE',
    TRAFFIC_LIGHT: 'geocoder.poi.TRAFFIC_LIGHT',
    TRAFFIC_SERVICE_CENTER: 'geocoder.poi.TRAFFIC_SERVICE_CENTER',
    TRAFFIC_SIGN: 'geocoder.poi.TRAFFIC_SIGN',
    TRAIL_SYSTEM: 'geocoder.poi.TRAIL_SYSTEM',
    TRANSPORT_AUTHORITY: 'geocoder.poi.TRANSPORT_AUTHORITY VEHICLE_REGISTRATION',
    TRUCK_STOP: 'geocoder.poi.TRUCK_STOP',
    VETERINARIAN: 'geocoder.poi.VETERINARIAN',
    WATER_SPORT: 'geocoder.poi.WATER_SPORT',
    WEIGH_STATION: 'geocoder.poi.WEIGH_STATION',
    WELFARE_ORGANIZATION: 'geocoder.poi.WELFARE_ORGANIZATION',
    WINERY: 'geocoder.poi.WINERY',
    ZOOS_ARBORETA_BOTANICAL_GARDEN: 'geocoder.poi.ZOOS_ARBORETA_BOTANICAL_GARDEN',
};
